import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_MORTGAGES: MijnRoute = {
    path: 'hypotheken',
    navigationEvent: 'toZelfRegelenHypotheken',
    regex: /^\/zelf-regelen\/hypotheken$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/hypotheken'
};
